import { render, staticRenderFns } from "./mobile.component.vue?vue&type=template&id=073ef80d"
import script from "./mobile.component.vue?vue&type=script&lang=ts"
export * from "./mobile.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports